import { DjangoTimeStamped, TimeStamped } from '../django';
import { DjangoEmployer, Employer, parseEmployer } from '../employer';
import { parseDate } from '../helpers/date';

export class Fee implements TimeStamped {
  id: string;
  justFirstInstallment: boolean;
  isEnabled: boolean;
  isPercentage: boolean;
  percentage: number;
  amount: number;
  minimumInstallmentCount: number;
  maximumInstallmentCount: number;
  minimumInstallmentAmount: number;
  maximumInstallmentAmount: number;
  employer: Employer;
  createdBy: string;
  modifiedBy: string;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;

  constructor(data: string | Fee | DjangoFee = {}) {
    if (data instanceof Fee) {
      bindFee(this, data);
    } else if (typeof data === 'string') {
      bindDjangoFee(this, { id: data });
    } else {
      bindDjangoFee(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

function getDjangoModel(fee: Fee) {
  return {
    id: fee.id,
    just_first_installment: fee.justFirstInstallment,
    is_enabled: fee.isEnabled,
    is_percentage: fee.isPercentage,
    percentage: fee.percentage,
    amount: fee.amount,
    minimum_installment_count: fee.minimumInstallmentCount,
    maximum_installment_count: fee.maximumInstallmentCount,
    minimum_installment_amount: fee.minimumInstallmentAmount,
    maximum_installment_amount: fee.maximumInstallmentAmount,
    employer: fee.employer,
    created_by: fee.createdBy,
    modified_by: fee.modifiedBy,
    created: fee.created,
    modified: fee.modified,
  };
}

function bindFee(fee: Fee, data: Fee) {
  fee.id = data.id;
  fee.justFirstInstallment = data.justFirstInstallment;
  fee.isEnabled = data.isEnabled;
  fee.isPercentage = data.isPercentage;
  fee.percentage = data.percentage;
  fee.amount = data.amount;
  fee.minimumInstallmentCount = data.minimumInstallmentCount;
  fee.maximumInstallmentCount = data.maximumInstallmentCount;
  fee.minimumInstallmentAmount = data.minimumInstallmentAmount;
  fee.maximumInstallmentAmount = data.maximumInstallmentAmount;
  fee.employer = data.employer;
  fee.createdBy = data.createdBy;
  fee.modifiedBy = data.modifiedBy;
  fee.created = data.created;
  fee.modified = data.modified;
}

function bindDjangoFee(fee: Fee, data: DjangoFee) {
  fee.id = data.id;
  fee.justFirstInstallment = data.just_first_installment;
  fee.isEnabled = data.is_enabled;
  fee.isPercentage = data.is_percentage;
  fee.percentage = Number(data.percentage);
  fee.amount = Number(data.amount);
  fee.minimumInstallmentCount = Number(data.minimum_installment_count);
  fee.maximumInstallmentCount = Number(data.maximum_installment_count);
  fee.minimumInstallmentAmount = Number(data.minimum_installment_amount);
  fee.maximumInstallmentAmount = Number(data.maximum_installment_amount);
  fee.employer = parseEmployer(data.employer);
  fee.createdBy = data.created_by;
  fee.modifiedBy = data.modified_by;
  fee.created = parseDate(data.created);
  fee.modified = parseDate(data.modified);
}

export function parseFee(data?: string | Fee | DjangoFee) {
  if (data) {
    return new Fee(data);
  } else {
    return undefined;
  }
}

export interface DjangoFee extends DjangoTimeStamped {
  id?: string;
  just_first_installment?: boolean;
  is_enabled?: boolean;
  is_percentage?: boolean;
  percentage?: number;
  amount?: number;
  minimum_installment_count?: number;
  maximum_installment_count?: number;
  minimum_installment_amount?: number;
  maximum_installment_amount?: number;
  employer?: DjangoEmployer;
  created_by?: string;
  modified_by?: string;
  created?: string;
  modified?: string;
}
